import React from "react";
import PropTypes from "prop-types";
import moment from "moment";
import get from "lodash.get";
import styled from "@emotion/styled";
import { injectIntl } from "react-intl";

import Button from "components/Button";
import DatePicker from "components/DatePicker";
import SelectField from "components/SelectField";

import ParkkiTheme from "themes/ParkkiTheme";

const FiltersContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: row;
  align-items: flex-start;
  margin: ${ParkkiTheme.spacings.tiny};
  max-height: 50px;
`;

const FilterContainer = styled.div`
  margin-top: 7px;
  margin-left: ${ParkkiTheme.spacings.small};
  margin-right: ${ParkkiTheme.spacings.small};
`;

const SelectContainer = styled(FilterContainer)`
  width: 225px;
`;

const StyledButton = styled(Button)`
  align-self: flex-end;
`;

class VisitorCharacteristicsFilters extends React.Component {
  shouldDisableStartDate = (date) => {
    const { startDate } = this.props;
    const minStartDate = moment().subtract(
      get(startDate, "maxDaysAllowed"),
      "days"
    );

    return date.isAfter(moment(), "day") || date.isBefore(minStartDate, "day");
  };

  shouldDisabledEndDate = (date) => {
    return date.isAfter(moment(), "day");
  };

  render() {
    const { area, intl, endDate, onSearch, startDate } = this.props;

    return (
      <FiltersContainer>
        <FilterContainer>
          <DatePicker
            value={startDate.value}
            label={startDate.label}
            onChange={startDate.onChange}
            shouldDisableDate={this.shouldDisableStartDate}
          />
        </FilterContainer>

        <FilterContainer>
          <DatePicker
            value={endDate.value}
            label={endDate.label}
            onChange={endDate.onChange}
            shouldDisableDate={this.shouldDisabledEndDate}
          />
        </FilterContainer>
        {area.values?.length ? (
          <SelectContainer>
            <SelectField
              id="area-filters"
              label={intl.messages["visitorCharacteristicsScene.filters.area"]}
              values={area.values.map((item) => ({
                value: item?.id,
                text: item?.long_name,
              }))}
              value={area.value}
              onChange={(event) => {
                return (
                  get(event, "target.value") &&
                  area.onChange(get(event, "target.value"))
                );
              }}
            />
          </SelectContainer>
        ) : null}

        <StyledButton
          fullWidth={false}
          label={intl.messages["components.buttons.search"]}
          color="primary"
          onClick={onSearch}
        >
          {intl.messages["components.buttons.search"]}
        </StyledButton>
      </FiltersContainer>
    );
  }
}

VisitorCharacteristicsFilters.defaultProps = {};

VisitorCharacteristicsFilters.propTypes = {
  endDate: PropTypes.shape({
    value: PropTypes.number.isRequired,
    label: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
  }).isRequired,
  startDate: PropTypes.shape({
    value: PropTypes.number.isRequired,
    label: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
  }).isRequired,
  onSearch: PropTypes.func.isRequired,
};

export default injectIntl(VisitorCharacteristicsFilters);
